define(function (require) {

	//models
	const IPSModel = require('civicsBase/ipsModel');
	const map_extent_model = require('civicsModels/location/map_extent_model');

	//collections
	const IPSCollection = require('civicsBase/ipsModelCollection');

	const Big = require('civicsUtils/libraries/big');

	const CN = require('civicsUtils/constants');
	const address = 'address';
	const parcel = 'parcel';
	const asset = 'asset';
	const property = 'property';

	return {
		//this layers list is ONLY to be used for setting up the default layers on a map.
		//once the map has rendered, we want to use this.activeMapLayers instead.
		//we set this.activeMapLayers equal to the output here just to make sure we HAVE an active layer in case map is disabled.
		buildLayerList: function (primarySiteTypes, additionalSiteTypes, assetTypes) {
			let layers = [];
			if ((!this.primarySiteHiddenByConstraints && (primarySiteTypes & CN.ADDRESS)) || 
				(!this.additionalSitesHiddenByConstraints && (additionalSiteTypes & CN.ADDRESS))) 
			{
				layers.push({ 
					ipsComponentType: 'Hansen.Property.Address',
					siteType: 'address'
			 	})
			}
			if ((!this.primarySiteHiddenByConstraints && (primarySiteTypes & CN.PARCEL)) || 
				(!this.additionalSitesHiddenByConstraints && (additionalSiteTypes & CN.PARCEL))) 
			{
				layers.push({ 
					ipsComponentType: 'Hansen.Property.Parcel',
					siteType: 'parcel'
				 })
			}
			if ((!this.primarySiteHiddenByConstraints && (primarySiteTypes & CN.ASSET)) || 
				(!this.additionalSitesHiddenByConstraints && (additionalSiteTypes & CN.ASSET)))
			{
				assetTypes.forEach(type => {
					layers.push({
						ipsComponentType: 'Hansen.AssetManagement.Asset',
						assetType: type.id,
						title:type.displayName,
						siteType: 'asset'
					});
				});
			}
			//should never hit for now, but will happen eventually
			if (primarySiteTypes & CN.PROPERTY) {
				//Figure out what to do with properties when we implement.
				//layers.push({ ipsComponentType: 'property' })
			}

			if (this.activeMapLayers == null) {
				this.activeMapLayers = layers;
				//activeMapLayers will change but default will always be the default available in case we need to reference.
				this.defaultLayers = layers;
			}
			return layers;
		},
		addCoordinatesInCollectionAndPlacePin: function (coordinates, collection) {
			collection.add(new Backbone.Model({
					clickLocationPin:true,
					Spatial: {
						xCoordinate: coordinates.x,
						yCoordinate: coordinates.y
			}}))
		},
		centerMapOnCoordinatesAndPlacePin: function (coordinates) {
			var mdl = new IPSModel({
				Spatial: {
					xCoordinate: coordinates.x,
					yCoordinate: coordinates.y
				},
				internalIcon:'*'
			});
			var col = new IPSCollection();
			col.add(mdl);
			
			this.trigger('collection:updated', {
				collection: col
			});
		},
		centerMapOnCoordinatesAndPlacePinWithSelectedSites:function(coordinates){
			var mdl = new IPSModel({
				Spatial: {
					xCoordinate: coordinates.x,
					yCoordinate: coordinates.y
				},	
				internalIcon:'*'
			});
			var col = new IPSCollection(this.selectedSitesCollection.toJSON());
			col.add(mdl);
			
			this.trigger('collection:updated', {
				collection: col
			});
		},
		showAllSelectedSitesOnMap:function(){
			var mergedCollection = new Backbone.Collection();
			if(this.selectedSitesCollection) mergedCollection.add(this.selectedSitesCollection.models);
			if(this.nearbySitesCollection) mergedCollection.add(this.nearbySitesCollection.models);
			// this.trigger('collection:updated',{
			// 	collection: this.selectedSitesCollection
			// });
			this.trigger('collection:updated',{
				collection: mergedCollection
			});
		},
		fetchMapExtent: function (mapConfigName) {
			var prom = $.Deferred();
			var extentModel = new map_extent_model();
			extentModel.mapName = mapConfigName;
			extentModel.fetch().done(() => {
				prom.resolve(extentModel.toJSON());
			})
			return prom;
		},
		findCenterPoint: function (box) {
			if (box && box.length == 4) {
				var x1 = new Big(box[0]);
				var x2 = new Big(box[2]);
				var y1 = new Big(box[1]);
				var y2 = new Big(box[3]);

				var x = (x1.plus(x2)).div(2);
				var y = (y1.plus(y2)).div(2);
				return ({ x: x.toString(), y: y.toString() });
			}
			return null;
		},
		getExtentFromConfig(config) {
			var ret = '';
			if (config
				&& config.cdrNewLocation
				&& config.cdrNewLocation.autocompleteMinLat != ''
				&& config.cdrNewLocation.autocompleteMinLon != ''
				&& config.cdrNewLocation.autocompleteMaxLat != ''
				&& config.cdrNewLocation.autocompleteMaxLon != '') {
				ret = config.cdrNewLocation.autocompleteMinLat + ',' +
					config.cdrNewLocation.autocompleteMinLon + ',' +
					config.cdrNewLocation.autocompleteMaxLat + ',' +
					config.cdrNewLocation.autocompleteMaxLon
			}
			return ret;
		},
		mapClicked: function (res, extentSize) {
			
			if (res && res.raw && res.raw.args
				&& res.raw.args.in && res.raw.args.in.findOption) {
				var box = res.raw.args.in.findOption("box");
				var point = this.findCenterPoint(box);
				// this.resetLocation({ click: true });
				// this.locationObject.Spatial = {
				// 	xCoordinate: point.x,
				// 	yCoordinate: point.y
				// }
				//when we click, we center and pin right away. we don't move based on what IPS address we find
				this.mapClickedMethod=true;
				this.centerMapOnCoordinatesAndPlacePin(point);
				if(this.canAddSite()){
					this.getNearbySites(point, extentSize);		
				}else if(this.primarySiteHiddenByConstraints && this.additionalSitesHiddenByConstraints) {
					//map click disabled
					return;
				}else{
					this.showCannotAddSiteModal(res,extentSize);

				}
				this.resetErrorMessages();
			}
		},
		isPointInExtent(coordinates, extent) {
			var ret = true;
			if (extent && extent.length > 0) {
				var split = extent.split(',');
				if (split.length == 4) {
					var minX = new Big(split[0]);
					var minY = new Big(split[1]);
					var maxX = new Big(split[2]);
					var maxY = new Big(split[3]);
					var x = new Big(coordinates.x);
					var y = new Big(coordinates.y);
					//the big library uses gte for >=, and lte for <=
					if (!(minX.lte(x) && maxX.gte(x)
						&& minY.lte(y) && maxY.gte(y))) {
						ret = false;
					}
				}
			} else {
				//if we don't have an extent at all, we can't really tell if it's in the extent.
				ret = false;
			}
			return ret;
		},
		updateMapLayers: function (mapLayers) {
			if (mapLayers == undefined) return;
			let activeLayers = mapLayers.filter(layer => layer.visible && layer.componentType!=undefined);
			this.activeMapLayers = activeLayers.map((layer) => {
				let siteType = '';
				let split = layer.componentType.split('.');
				if(split.length == 3){
					siteType = split[2].toLowerCase();//this will be address, asset, parcel, etc
				}
				return {
					ipsComponentType: layer.componentType,
					assetType: layer.assetType,
					title: layer.title,
					siteType:siteType
				}
			});
			//if we have no layers, nothign works. revert to default.
			if (this.activeMapLayers.length == 0) {
				this.activeMapLayers = this.defaultLayers
			}
			this.updateAutocompleteLayerData(this.activeMapLayers);
		},
		/** FUNCTIONS FOR SETTING CUSTOM MARKERS FOR SITE COLLECTIONS */
		updateSelectedSiteIndexesAndIcons:function(silent = true){
			//we need to manually update the indexes of the collection when we make changes to the collection.
			//It'd be great to call from collection.on('update') but we'd end up in a loop.
			//set this silently if we are updating the collection manually later.
			//internalIcon for "sites" symbology:
				// 1-Primary site icon
				// 2-Additional sites icon
				// 3-Nearby sites icon
			let index = 1;//starting at 1 because this is for display purposes.
			this.selectedSitesCollection.forEach((site)=>{
				if(site.get('primarySite')!==true){
					site.set({
						_siteIndex:index,
						internalSymbology:'sites',
						internalLabel:index++,
						internalIcon:2,
						_canBePrimarySite:this.canBePrimarySite(site)
					},{silent:silent});
				} else {
					site.set({
						internalSymbology:'sites',
						internalIcon:1
					}, {silent:silent});
				}
			});
			this.updateAllowedSiteTypes();
			//any time we update selected sites, we need to close the location picker. updating the selected 
			//sites may mean we're adding a different site type than when we opened the location picker.
			this.closeLocationPicker();
		},
		updateAllowedSiteTypes:function(){
			this.updateAutocompleteLayerData(this.activeMapLayers);
		},

		/* NEARBY SITES COLLECTION FUNCTIONS */
		updateNearbySitesIndexesAndIcons:function(silent = true){
			//let index = 1;//starting at 1 because this is for display purposes.
			this.nearbySitesCollection.forEach((site)=>{
				if(site.get('clickLocationPin')!==true){
					site.set({
						//_siteIndex: index,
						internalSymbology:'sites',
						internalLabel:site.get('_siteIndex'), //label is the display of the marker index
						internalIcon:3
					},{silent:silent});
				}

			})
			this.trigger('collection:cleared');		
			this.trigger('collection:updated', {
				collection: this.nearbySitesCollection
			})
		},
		removeMapProperty: function(collection){
			collection.forEach((ss) =>{
				ss.unset('_ZOOM_TO_PIN_');
			})
		}

	}
});